import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploaderComponent } from './uploader/uploader.component';
import { MaterialModule } from '../material/material.module';
import { PipesModule } from '../../pipes/pipes.module';
import { ArchivoService } from '../../providers/archivo.service';
import { DownloaderComponent } from './downloader/downloader.component';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    UploaderComponent,
    DownloaderComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    PipesModule,
    MaterialModule,
    MaterialFileInputModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    UploaderComponent,
    DownloaderComponent,
  ],
  providers: [
    ArchivoService
  ]
})
export class ArchivoModule { }
